// import React from "react";
// import Chart from "react-apexcharts";

// const ZoomModal = ({ id, title, chartOptions, seriesData }) => {
//   if (!chartOptions || !seriesData) return null;

//   return (
//     <div
//       className="modal fade"
//       id={id}
//       tabIndex="-1"
//       aria-hidden="true"
//       data-bs-backdrop="true"
//     >
//       <div className="modal-dialog modal-fullscreen modal-dialog-centered">
//         <div className="modal-content rounded-0">
//           <div className="modal-header border-0">
//             <h5 className="modal-title fw-semibold">{title}</h5>
//             <button
//               type="button"
//               className="btn-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//             ></button>
//           </div>
//           <div className="modal-body text-center">
//             <Chart
//               options={chartOptions}
//               series={seriesData}
//               type="donut"
//               height={350}
//             />
//             <div className="mt-3">
//               <h6 className="fw-semibold">Key Points</h6>
//               {seriesData.map((val, i) => (
//                 <p key={i}>
//                   {chartOptions.labels[i]} = {val}
//                 </p>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ZoomModal;
// import React, { useEffect, useRef } from "react";
// import Chart from "react-apexcharts";

// const ZoomModal = ({ id, title, chartOptions, seriesData, type,height }) => {
//   const chartRef = useRef(null);

//   // Initialize bootstrap modal
//  useEffect(() => {
//   const modalEl = document.getElementById("zoomModal");

//   // ✅ Access bootstrap safely from window
//   const bs = window.bootstrap;

//   if (modalEl && bs) {
//     bs.Modal.getOrCreateInstance(modalEl);
//   }
// }, []);



//   if (!chartOptions || !seriesData) return null;

//   return (
//     <div className="modal fade" id={id} tabIndex="-1" aria-hidden="true" data-bs-backdrop="true">
//       <div className="modal-dialog modal-fullscreen modal-dialog-centered">
//         <div className="modal-content ">
//           <div className="modal-header">
//             <h5 className="modal-title">{title || "Zoomed Chart"}</h5>
//             <button
//               type="button"
//               className="btn-close"
//               data-bs-dismiss="modal"
//               aria-label="Close"
//             ></button>
//           </div>
//           <div className="modal-body p-3">
//             <Chart
//               ref={chartRef}
//               options={chartOptions}
//               series={seriesData}
//               type={type || chartOptions.chart?.type || "bar"}
//               height={height}
//               width="100%"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ZoomModal;

import React from "react";
import Chart from "react-apexcharts";
import Modal from "../../admin/components/common/Model";
import { toastEmitter } from "../../utills/utilities";
import { CHAT_ICON, MENU_ICON, ZOOM_ICON } from "../../utills/image-constant";

const ZoomModal = ({
  id,
  title,
  chartOptions,
  seriesData,
  type,
  height,
  remarkText,
  setRemarkText,
  showRemarkModal,
  setShowRemarkModal,
  modalRef,
  exportSummaryToExcel,
  exportAsPDF,
  exportAsImage,
}) => {
    if (!chartOptions || !seriesData) {
    return null; 
  }
 
 
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}-label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title fw-semibold" id={`${id}-label`}>
              {title}
            </h5>

            {/* Toolbar (same as main chart) */}
            <div className="d-flex align-items-center">
              {/* Dropdown */}
              <div className="dropdown me-2">
                <button
                  className="icon-btn bg-transparent"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={MENU_ICON} alt="menu" />

                </button>
                <ul className="dropdown-menu ">
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={exportSummaryToExcel}
                    >
                      <i className="bi bi-file-earmark-excel"></i> Download Excel
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={exportAsPDF}
                    >
                      <i className="bi bi-file-earmark-pdf"></i> Export PDF
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={exportAsImage}
                    >
                      <i className="bi bi-image"></i> Download Image
                    </button>
                  </li>
                </ul>
              </div>

              {/* Close Button */}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div className="modal-body text-center position-relative">
            <Chart
              options={chartOptions}
              series={seriesData}
              height={height}
              width="100%"
              type={type || chartOptions.chart?.type || "bar"}

            />

            {/* Add Comment Floating Button */}
            <button
              title="Add Comment"
              onClick={() => {
                setShowRemarkModal(true);
                setTimeout(() => {
                  if (modalRef?.current) modalRef.current.click();
                }, 0);
              }}
              className="border-0 bg-transparent position-absolute"
              style={{
                bottom: "15px",
                right: "15px",
              }}
            >
              <img src={CHAT_ICON} alt="chat" />

            </button>

            {/* Remark Modal */}
            {showRemarkModal && (
              <Modal modalClick={modalRef} title="Remark" buttonLable="">
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Add remark"
                  value={remarkText}
                  onChange={(e) => setRemarkText(e.target.value)}
                />
                <div className="text-end mt-3">
                  <button
                    className="btn btn-secondary me-2"
                    data-bs-dismiss="modal"
                    onClick={() => setShowRemarkModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      toastEmitter("success", `Remark added`);
                      setShowRemarkModal(false);
                    }}
                  >
                    Add Remark
                  </button>
                </div>
              </Modal>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoomModal;